const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

export const getProxiedImageUrl = (url) => {
  if (!url) return null;
  if (url.startsWith('data:') || url.startsWith('blob:') || url.includes('/api/proxy-image')) {
    return url;
  }
  if (url.startsWith('http')) {
    // The proxy now requires auth. Canvas/<img> loads with crossOrigin
    // 'anonymous' don't send cookies or headers, so pass the logged-in token
    // as a query param (it's always present in localStorage while the user is
    // using the editor).
    let token = '';
    try {
      token = window.localStorage.getItem('token') || '';
    } catch (e) {
      token = '';
    }
    const tokenParam = token ? `&token=${encodeURIComponent(token)}` : '';
    return `${API_BASE}/api/proxy-image?url=${encodeURIComponent(url)}${tokenParam}`;
  }
  return url;
};

export const REALPROP_GOLD = '#D4AF37';

export const FONTS = [
  { value: 'Playfair Display', label: 'Playfair Display' },
  { value: 'Montserrat', label: 'Montserrat' },
  { value: 'Roboto', label: 'Roboto' },
  { value: 'Open Sans', label: 'Open Sans' },
  { value: 'Lato', label: 'Lato' },
  { value: 'Poppins', label: 'Poppins' },
  { value: 'Raleway', label: 'Raleway' },
  { value: 'Oswald', label: 'Oswald' },
  { value: 'Merriweather', label: 'Merriweather' },
  { value: 'PT Sans', label: 'PT Sans' },
  { value: 'Source Sans Pro', label: 'Source Sans Pro' },
  { value: 'Ubuntu', label: 'Ubuntu' },
  { value: 'Nunito', label: 'Nunito' },
  { value: 'Work Sans', label: 'Work Sans' },
  { value: 'Quicksand', label: 'Quicksand' },
  { value: 'Bebas Neue', label: 'Bebas Neue' },
  { value: 'Dancing Script', label: 'Dancing Script' },
  { value: 'Pacifico', label: 'Pacifico' },
  { value: 'Arial', label: 'Arial' },
  { value: 'Georgia', label: 'Georgia' },
  { value: 'Times New Roman', label: 'Times New Roman' },
];

export const PHOTO_GRIDS = [
  {
    id: '2-horizontal',
    name: '2 Photos (Horizontal)',
    slots: [
      { x: 0, y: 0, w: 0.5, h: 1 },
      { x: 0.5, y: 0, w: 0.5, h: 1 }
    ]
  },
  {
    id: '2-vertical',
    name: '2 Photos (Vertical)',
    slots: [
      { x: 0, y: 0, w: 1, h: 0.5 },
      { x: 0, y: 0.5, w: 1, h: 0.5 }
    ]
  },
  {
    id: '3-horizontal',
    name: '3 Photos (Row)',
    slots: [
      { x: 0, y: 0, w: 0.333, h: 1 },
      { x: 0.333, y: 0, w: 0.334, h: 1 },
      { x: 0.667, y: 0, w: 0.333, h: 1 }
    ]
  },
  {
    id: '3-feature',
    name: '3 Photos (Feature Left)',
    slots: [
      { x: 0, y: 0, w: 0.6, h: 1 },
      { x: 0.6, y: 0, w: 0.4, h: 0.5 },
      { x: 0.6, y: 0.5, w: 0.4, h: 0.5 }
    ]
  },
  {
    id: '4-grid',
    name: '4 Photos (Grid)',
    slots: [
      { x: 0, y: 0, w: 0.5, h: 0.5 },
      { x: 0.5, y: 0, w: 0.5, h: 0.5 },
      { x: 0, y: 0.5, w: 0.5, h: 0.5 },
      { x: 0.5, y: 0.5, w: 0.5, h: 0.5 }
    ]
  },
  {
    id: '5-feature',
    name: '5 Photos (Feature)',
    slots: [
      { x: 0, y: 0, w: 0.667, h: 1 },
      { x: 0.667, y: 0, w: 0.333, h: 0.5 },
      { x: 0.667, y: 0.5, w: 0.333, h: 0.5 },
      { x: 0, y: 0, w: 0.333, h: 0.5 },
      { x: 0.333, y: 0, w: 0.334, h: 0.5 }
    ]
  },
  {
    id: '5-grid',
    name: '5 Photos (Mixed)',
    slots: [
      { x: 0, y: 0, w: 0.5, h: 0.6 },
      { x: 0.5, y: 0, w: 0.5, h: 0.6 },
      { x: 0, y: 0.6, w: 0.333, h: 0.4 },
      { x: 0.333, y: 0.6, w: 0.334, h: 0.4 },
      { x: 0.667, y: 0.6, w: 0.333, h: 0.4 }
    ]
  },
];
